import { connect } from 'react-redux';
import { playResponseAudio, stopResponsePlaying } from '../../questions/questionsActions';
import AnswerButton from './AnswerButtonView';
import { blockScreen, unblockScreen } from '../../screen/screenActions';
import selectors from '../../../rootSelectors';

const mapStateToProps = (state, ownProps) => ({
    isResponsePlaying: selectors.getPlayingResponseIndex(state) === ownProps.index,
    hasAudio: !!ownProps.audio,
    isDisabled: ownProps.isDisabled,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    stopPlaying: () => {
        dispatch(stopResponsePlaying());
    },
    onStimulusClick: () => {
        dispatch(blockScreen());
        return dispatch(playResponseAudio(ownProps.audio, ownProps.index)).then(() => {
            dispatch(unblockScreen());
        });
    },
});

const AnswerButtonContainer = connect(mapStateToProps, mapDispatchToProps)(AnswerButton);

export default AnswerButtonContainer;
